import React from 'react';
import {CreateGuesser} from "@api-platform/admin";

const CardGameCreate = props => (
        <CreateGuesser {...props} resource="card-games"/>
);

export default CardGameCreate;
